"use client";

import { authenticationSlice } from "@/lib/features/authentication/frontend";
import { useAppDispatch } from "@/lib/hooks";
import { useResetPassword } from "@/src/hooks/authenticationHooks";
import { isStrongPassword } from "@/src/utilities/passwordValidation";
import { Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import RequiredBox from "./Fields/RequiredBox";
import { ValidatedSubmitButton } from "./Fields/ValidatedSubmitButton";
import { PasswordResetUser } from "@/lib/features/authentication/types";

export default function ResetPasswordForm({
    token
} : PasswordResetUser) {
  const [newPassword, setNewPassword] = useState("");

  const { handleReset, verified, requestingReset } = useResetPassword();

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(
        authenticationSlice.actions.verify({
          key: "username",
          value: true,
        })
      );
  }, [dispatch]);

  return (
    <form onSubmit={handleReset} method="post">
      <input type="hidden" name="token" value={token || ""} />
      <RequiredBox
        name="password"
        title="New Password"
        type="password"
        helper={
          <Typography level="body-xs">
            Must be at least 8 characters, with at least 1 number and 1 capital
            letter
          </Typography>
        }
        validationFunction={(value: string) => {
          setNewPassword(value);
          return isStrongPassword(value);
        }}
        disabled={requestingReset}
      />
      <RequiredBox
        name="confirmPassword"
        title="Confirm New Password"
        placeholder="Confirm New Password"
        type="password"
        validationFunction={(value: string) =>
          value === newPassword && value.length >= 8
        }
        disabled={requestingReset}
      />
      <ValidatedSubmitButton
        authenticating={requestingReset}
        valid={verified && !!token}
        fullWidth
      />
    </form>
  );
}
